import React from 'react';
import { Box, Center } from '@tapresearch/ui/components';

export const NoResultsFound = () => {
  return (
    <Center
      my={8}
      fontSize="md"
      color="gray.500"
      fontWeight="medium"
      variant="center"
      flexDirection="column"
      alignItems="flex-start"
      p={4}
    >
      <Box mb={2}>
        No responses to this question were found matching your filter criteria.
      </Box>
      Please try different or less specific filter options.
    </Center>
  );
};
